import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { AppConfigService } from '../app-config.service';

@Injectable({ providedIn: 'root' })
export class CRMAccessService {
  private readonly appConfigService = inject(AppConfigService);

  //todo SNP-2854: Use new access check to check if user is an admin
  readonly canViewAllCampaigns$ = this.appConfigService.config$.pipe(
    map((config) => config.isSuperAdmin || config.userCanAccessMarketing),
  );

  //todo SNP-2854: Use new access check to check if user is an admin
  readonly canModifyAutomations$ = this.appConfigService.config$.pipe(
    map((config) => config.isSuperAdmin || config.userCanAccessAutomations),
  );

  //todo SNP-2854: Use new access check to check if user is an admin DO NOT USE
  readonly hasAdminPermission$ = this.appConfigService.config$.pipe(map((_) => true));

  //todo SNP-2854: fix access check
  readonly canAccessSales$ = this.appConfigService.config$.pipe(
    map((config) => config.isSuperAdmin || config.userCanAccessSales || true),
  );

  //todo SNP-2854: fix access check
  readonly canAccessOrders$ = this.appConfigService.config$.pipe(
    map((config) => config.isSuperAdmin || config.userCanAccessOrders || true),
  );

  //todo SNP-2854: fix access check
  readonly canAccessAutomations$ = this.appConfigService.config$.pipe(
    map((config) => config.isSuperAdmin || config.userCanAccessAutomations || true),
  );
}
